import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    INT evaluates to the integer part of the given numeric term.
    The numeric parameter has to be a floating point number. If the term is not numeric, the BASIC error ?TYPE MISMATCH ERROR occurs.
    When the numeric argument is absent, it displays a ?SYNTAX ERROR. 
*/
export const int = async (args) => {
    // Example of valid args:
    // INT(10.5) (Screen: 10)
    // INT(-10.5) (Screen: -11)
    // INT("Text") (Screen: ?TYPE MISMATCH  ERROR)
    // INT() (Screen: ?SYNTAX  ERROR)
    // Check if args are a number or a mathematical expression.

    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    const result = Math.floor(args);

    // Check if the result is within the range of a floating point value.
    if (result > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the integer part of the result.
    return result;
};